module.exports = __webpack_public_path__ + "static/media/logo-cardapio-do-barriga.07ef08fb.svg";